import { Component, OnInit } from '@angular/core';
import { CompetitionDocumentsFilterService } from '../../services/competition-documents-filter.service';

@Component({
  selector: 'app-bootstrap-competition-documents',
  templateUrl: './bootstrap-competition-documents.component.html',
  styleUrls: ['./bootstrap-competition-documents.component.scss']
})
export class BootstrapCompetitionDocumentsComponent{

  constructor(public competition_documents_service:CompetitionDocumentsFilterService) { }



}
